import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { CardMode } from '@components/card/card.component';
import {
    FlightPreferencesComponent,
    FlightPreferencesFormGroup,
} from '@components/molecules/forms/patient-travel-card/flight-preferences/flight-preferences.component';
import { MdsDividerComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequest } from '@models/request';
import { Study, SupportTier } from '@models/study';
import { RequestStateService } from '@services/state-management/request-state.service';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getAlertContent } from '@utility/utility.travel-request';
import { map } from 'rxjs';
import { FlightRequestDetailsFormGroup } from '../../form-groups/detail-form-groups/travel/flight-request.formgroup';
import { NeedsTravelFormGroup, TravelFormGroup } from '../../form-groups/travel-request-card.formgroup';
import { NeedsTravelRadioGroupComponent } from '../../needs-travel-radio-group/needs-travel-radio-group.component';
import { FlightRequestDetailsComponent } from './flight-request-details/flight-request-details.component';

@Component({
    selector: 'medpace-flight-travel-request-tab',
    imports: [
        CommonModule,
        MdsDividerComponent,
        MdsExpansionPanelComponent,
        NeedsTravelRadioGroupComponent,
        FlightPreferencesComponent,
        FlightRequestDetailsComponent,
        AlertComponent,
    ],
    templateUrl: './flight-travel-request-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './flight-travel-request-tab.component.scss',
})
export class FlightTravelRequestTabComponent {
    private readonly requestStateService = inject(RequestStateService);
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly study: InputSignal<Study> = input.required();
    public readonly formGroup: InputSignal<
        NeedsTravelFormGroup<TravelFormGroup<FlightPreferencesFormGroup, FlightRequestDetailsFormGroup>>
    > = input.required();

    public readonly isFlightAvailable: Signal<boolean> = computed(
        () => !!this.study().studyInfo?.studyTravelOptions.find((o) => o.name === 'Flights')
    );
    public readonly isLimitedService = computed(() => this.study()?.supportTier === SupportTier.limitedService);
    public readonly isUpdate = computed(() => !!this.travelViewModelService.travelCardViewModel()?.isUpdate);

    public readonly isFlightRequested$ = this.requestStateService.travelRequestStateService
        .getState()
        .pipe(map((travelRequest: TravelRequest) => travelRequest?.flightRequired));

    public readonly nonAvailableMessage: string = getAlertContent('flight');
}
